/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{complex as e}from"../../../value/types/complex/index.js";import{filter as t}from"../../../value/types/complex/filter.js";import{getDefaultValueType as o}from"./defaults.js";function m(m,r){let i=o(m);return i!==t&&(i=e),i.getAnimatableNone?i.getAnimatableNone(r):void 0}export{m as getAnimatableNone};
//# sourceMappingURL=animatable-none.js.map
